import { Routes } from '@angular/router';
import { AuthenticationGuard } from './services/authentication/authentication-guard';


export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('src/app/map/map.routes').then(m => m.mapRoutes),
  },
  { path: 'home', redirectTo: '', pathMatch: 'full' },

  {
    path: 'admin',
    loadChildren: () => import('src/app/authentication/authentication.routes').then(m => m.administratorRoutes),
  },
  {
    path: 'private',
    loadChildren: () => import('src/app/private/private.routes').then(m => m.privateRoutes),
    canActivate: [AuthenticationGuard],
    canActivateChild: [AuthenticationGuard],
    data: { roles: ["Administrator", "Manager"] }
  },
  {
    path: 'operations',
    loadChildren: () => import('src/app/map/map.routes').then(m => m.mapRoutes),
  },
  {
    path: 'carte', redirectTo: 'operations', pathMatch: 'full',
  },
];
